module.exports = __webpack_public_path__ + "static/media/slide-or-middle.1ad8a0ec.svg";